/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountIdCondition } from '../models/AccountIdCondition';
import { AppsCondition } from '../models/AppsCondition';
import { BackupPolicyGroupCondition } from '../models/BackupPolicyGroupCondition';
import { CloudProviderCondition } from '../models/CloudProviderCondition';
import { DataClassesCondition } from '../models/DataClassesCondition';
import { EnvironmentCondition } from '../models/EnvironmentCondition';
import { RegionCondition } from '../models/RegionCondition';
import { ResourceGroupNameCondition } from '../models/ResourceGroupNameCondition';
import { ResourceIdCondition } from '../models/ResourceIdCondition';
import { ResourceNameCondition } from '../models/ResourceNameCondition';
import { ResourceTypeCondition } from '../models/ResourceTypeCondition';
import { SubnetsCondition } from '../models/SubnetsCondition';
import { TagKeyValuesCondition } from '../models/TagKeyValuesCondition';
import { TagKeysCondition } from '../models/TagKeysCondition';
import { VpcCondition } from '../models/VpcCondition';

/**
* Conditional expression to evaulate to determine which resources are to included in the backup policy. Used only when `resourceSelectionMode` is `CONDITIONAL`.  Only one of the expressions below can be used. For multiple conditions using `AND` or `OR` logic, group expressions with `group`. You can nest multiple groups to create more complex expressions. 
*/
export class BackupPolicyExpression {
  'group'?: BackupPolicyGroupCondition | null;
  'resourceType'?: ResourceTypeCondition | null;
  'dataClasses'?: DataClassesCondition | null;
  'environment'?: EnvironmentCondition | null;
  'apps'?: AppsCondition | null;
  'cloudProvider'?: CloudProviderCondition | null;
  'accountId'?: AccountIdCondition | null;
  'sourceRegion'?: RegionCondition | null;
  'vpc'?: VpcCondition | null;
  'subnets'?: SubnetsCondition | null;
  'resourceGroupName'?: ResourceGroupNameCondition | null;
  'resourceName'?: ResourceNameCondition | null;
  'resourceId'?: ResourceIdCondition | null;
  'tagKeys'?: TagKeysCondition | null;
  'tagKeyValues'?: TagKeyValuesCondition | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "group",
      "baseName": "group",
      "type": "BackupPolicyGroupCondition",
      "format": ""
    },
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "ResourceTypeCondition",
      "format": ""
    },
    {
      "name": "dataClasses",
      "baseName": "dataClasses",
      "type": "DataClassesCondition",
      "format": ""
    },
    {
      "name": "environment",
      "baseName": "environment",
      "type": "EnvironmentCondition",
      "format": ""
    },
    {
      "name": "apps",
      "baseName": "apps",
      "type": "AppsCondition",
      "format": ""
    },
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "CloudProviderCondition",
      "format": ""
    },
    {
      "name": "accountId",
      "baseName": "accountId",
      "type": "AccountIdCondition",
      "format": ""
    },
    {
      "name": "sourceRegion",
      "baseName": "sourceRegion",
      "type": "RegionCondition",
      "format": ""
    },
    {
      "name": "vpc",
      "baseName": "vpc",
      "type": "VpcCondition",
      "format": ""
    },
    {
      "name": "subnets",
      "baseName": "subnets",
      "type": "SubnetsCondition",
      "format": ""
    },
    {
      "name": "resourceGroupName",
      "baseName": "resourceGroupName",
      "type": "ResourceGroupNameCondition",
      "format": ""
    },
    {
      "name": "resourceName",
      "baseName": "resourceName",
      "type": "ResourceNameCondition",
      "format": ""
    },
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "ResourceIdCondition",
      "format": ""
    },
    {
      "name": "tagKeys",
      "baseName": "tagKeys",
      "type": "TagKeysCondition",
      "format": ""
    },
    {
      "name": "tagKeyValues",
      "baseName": "tagKeyValues",
      "type": "TagKeyValuesCondition",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupPolicyExpression.attributeTypeMap;
  }

  public constructor() {
  }
}

